module.exports = __webpack_public_path__ + "staticcomp/img/content_2plural.34a00cc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/3/5/content_2plural.jpg
// module id = l+Qc
// module chunks = 39